import { HandledError } from 'fitbeat.models';
import { Instructor } from 'fitbeat.models';
import { UserProfile } from '../../entities';
import {
  IInstructorsRepository,
  IUserProfileRepository,
  IWorkoutRepository,
} from '../../persistence/repositories/interfaces';
import { IInstructorsManager } from './iinstructorsmanager';

export class InstructorsManager implements IInstructorsManager {

    public static initializeInBackground(instructorsRepository: IInstructorsRepository,
                                         userProfileRepository: IUserProfileRepository,
                                         workoutRepository: IWorkoutRepository) {
        if (instructorsRepository) {
            instructorsRepository.createDefaultDoc()
              .catch((e) => { /* no logger, no-op */ });
        }
        return new InstructorsManager(instructorsRepository, userProfileRepository, workoutRepository);
    }

    private constructor(private instructorsRepository: IInstructorsRepository,
                        private userProfileRepository: IUserProfileRepository,
                        private workoutRepository: IWorkoutRepository) {
    }

    public async getAllActiveInstructors(): Promise<Instructor[]> {
        return this.instructorsRepository.getAllActive();
    }

    public getAllInstructors(): Promise<Instructor[]> {
        return this.instructorsRepository.getAll();
    }

    public getSelectedInstructor(): Promise<any> {
        throw new Error(`Method not implemented.`);
    }

    public async setWorkoutInstructor(workoutId: string, instructorId: string): Promise<void> {
        return await this.workoutRepository.updateWorkoutInstructorSetting(workoutId, instructorId);
    }

    public async setDefaultInstructor(userId: string, instructorId: string): Promise<UserProfile> {
        const userProfile: UserProfile | undefined = await this.userProfileRepository.get(userId);
        if (!userProfile) {
            throw new HandledError(`No user found with uid ${userId}`);
        }

        userProfile.homeWorkoutInstructor = instructorId;

        return await this.userProfileRepository.update(userProfile);
    }
}
